import { useTranslation } from "react-i18next";

import agreementTypes from "astrid-firestore/src/api/agreements/constants/agreementTypes";

import Form from "../../../../forms/components/Form/Form";
import ContentCard from "../../../../ui/components/ContentCard/ContentCard";

import AgreementAppendixForm from "../../AgreementAppendixForm/AgreementAppendixForm";

export default function AgreementAppendixesForm() {
	const { t } = useTranslation();
	const { watch } = Form.useFormContext();
	const isValid = Form.usePartialFormValidation(["part", "firstSignee"]);

	const [type, part, producer] = watch(["type", "part", "producer"]);

	return (
		<ContentCard header={t("appendixes", "Appendixes")} disabled={!isValid}>
			<Form.Form>
				{/* Cloud agreements are signed outside Astrid, so appendixes are optional. */}
				<AgreementAppendixForm
					type={type}
					part={part}
					producerId={producer?.id}
					required={type !== agreementTypes.CLOUD}
				/>
			</Form.Form>
		</ContentCard>
	);
}
